import { createSelector } from '@ngrx/store';

import { getRetentionState } from '../retention-feature.selector';

export const getCurrentContract = createSelector(
  getRetentionState,
  (state) => state.currentContract.contract ?? undefined
);

export const getCurrentContractLoading = createSelector(
  getRetentionState,
  (state) => state.currentContract.tariffs.status === 'PENDING'
);
